// 画面最上部の見出し
import React from 'react';
import { convertLine } from '../Convert';
interface Props {
  label: string;
}

const TopHeading: React.FC<Props> = ({ label }) => {
  return <div className="heading-l">{convertLine(label)}</div>;
};

export default TopHeading;
